/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { SlicePipe } from "@angular/common";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  computed,
  forwardRef,
  inject,
  input,
  Input,
  signal,
} from "@angular/core";
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { EdCheckboxModule } from "@edenred/components/checkbox";
import { TranslocoPipe } from "@jsverse/transloco";

@Component({
  selector: "er-multi-select",
  standalone: true,
  imports: [NgSelectModule, EdCheckboxModule, SlicePipe, FormsModule, TranslocoPipe],
  templateUrl: "./multi-select.component.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultiSelectComponent),
      multi: true,
    },
  ],
  styleUrls: ["./multi-select.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiSelectComponent implements ControlValueAccessor {
  @Input() items!: any[] | string[] | null | undefined;
  // QUESTION: Would it be cleaner to just have one or fewer inputs and group the properties under an object?
  @Input() bindLabel!: string;
  @Input() bindValue!: string;

  @Input() groupBy!: string;
  @Input() closeOnSelect = false;
  @Input() searchable = false;
  value = signal<any[]>([]);

  selectedElementsCleaned = computed(() => this.value() ?? []);

  @Input() useTranslations = false;
  @Input() minOneRequired = false;
  @Input() clearable = true;
  @Input() invalid = false;

  private cdr = inject(ChangeDetectorRef);

  onChange: any = () => {};
  onTouched: any = () => {};
  public isDisabled = false;

  writeValue(value: any): void {
    this.value.set(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onSelectChange(ev: any): void {
    this.onChange(this.value());
    if (this.minOneRequired) {
      this.items = this.items = this.items?.map((item) => ({
        ...item,
        disabled: false,
      }));
      if (ev.length === 1) {
        this.items = this.items?.map((item) => ({
          ...item,
          disabled: ev[0].label === item.label,
        }));
      }
    }
  }

  public setDisabledState(isDisabled: boolean) {
    this.isDisabled = isDisabled;

    this.cdr.detectChanges();
  }
}
